import React, { FC, useCallback } from 'react';
import { Button } from '@manulife/mux';
import { Toggle } from '../Toggle';
import { ProductCardAttributesValues } from './ProductCard';

export const SelectPlanButton: FC<{
  selectPlanLabel: string;
  paxId: number;
  isValid: boolean;
  name: string;
  code: string;
  onSelect: (paxId: number, code: string, cardParams: ProductCardAttributesValues) => void;
  onDeselect: (paxId: number, code: string) => void;
  isSelected: boolean;
  values: ProductCardAttributesValues;
  id: string;
  isAddOn: boolean;
}> = ({ selectPlanLabel, paxId, isValid, name, isSelected, onSelect, onDeselect, code, values, id, isAddOn }) => {
  const onChangeCallback = useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();
      isSelected ? onDeselect(paxId, code) : onSelect(paxId, code, values);
    },
    [isSelected, onDeselect, paxId, code, values, onSelect]
  );
  return isAddOn ? (
    <Toggle checked={isSelected} disabled={!isValid} onChange={onChangeCallback} id={id} name={`${paxId}-${code}`}>
      {selectPlanLabel}
    </Toggle>
  ) : (
    <Button
      aria-label={`${selectPlanLabel} ${name}`}
      disabled={!isValid}
      aria-disabled={!isValid}
      type="button"
      className={`mx-auto btn ${isSelected ? 'btn-primary' : 'btn-secondary'}`}
      variant={isSelected ? 'primary' : 'secondary'}
      onClick={onChangeCallback}
      id={id}>
      {selectPlanLabel}
    </Button>
  );
};
SelectPlanButton.displayName = 'SelectPlanButton';
export default SelectPlanButton;
